import {
  type FillApplicationState,
  FillOpeningState,
  type IntakeUploadResult,
} from '@/models/fillApplication'
import type { Org } from '@/models/user'
import type { FillStep } from './fillSteps'
import { FmcsaView } from './FmcsaView'
import { FormView } from './FormView'
import { ReadOnlyNotice } from './ReadOnlyNotice'
import { StartView } from './StartView'

interface OpeningViewProps {
  org: Org
  state: FillApplicationState
  /** The tab the form opens on, when the documents step decided it. */
  initialStep: FillStep | null
  onUploaded: (result: IntakeUploadResult) => void
}

/** The view the page state's opening state names. */
export function OpeningView({ org, state, initialStep, onUploaded }: OpeningViewProps) {
  switch (state.openingState) {
    case FillOpeningState.READ_ONLY:
      return <ReadOnlyNotice status={state.orgStatus} />
    case FillOpeningState.FMCSA:
      return (
        <FmcsaView
          orgId={org.id}
          initialDot={org.business?.dotNumber ?? ''}
          duplicateOf={state.duplicateOf}
        />
      )
    case FillOpeningState.DROPZONE:
      return <StartView orgId={org.id} duplicateOf={state.duplicateOf} onUploaded={onUploaded} />
    default:
      return <FormView orgId={org.id} organisation={org} state={state} initialStep={initialStep} />
  }
}
